module.exports = __webpack_public_path__ + "static/media/dashboardInventory_fr.dc2adf2e.png";